<!-- 家长端首页-上课组件 -->
<template>
  <div class="home-schedule-comp schedule-content">
    <div class="schedule-box">
      <div 
        class="schedule-item" 
        v-for="(course,index) in courseData" 
        @click="$router.push('/classSchedule?date=' + (app.tool.date.formatDatetime(course.startTime, 'yyyy-MM-dd')))"
        :key="index">
        <div class="date">{{course.startTime | defineFormatDate}}</div>
        <div class="content">
          <div class="time">{{course.startTime | formatDatetime("hh:mm")}}<span class="t1">上课</span></div>
          <div class="t2 van-ellipsis">
            <span v-if="course.coursePlanType === 0">{{ course.className }}</span> 
            <span v-else>{{ course.curriculumName }}</span>
          </div>
          <div class="t2 van-ellipsis">{{course.studentName}}</div>
          <svg
            v-if="course.haveLeave"
            class="end-icon"
            aria-hidden="true"
          >
            <use
              xlink:href="#vxm-icon-yiqingjia"
            ></use>
          </svg>
        </div>
      </div>
    </div>
    <div class="schedule-more" 
      v-if="courseData.length>0" 
      @click="$router.push('/classSchedule')">查看课表
      <van-icon name="arrow" size="var(--fs-lg)" color="var(--g5)"/>
    </div>
    <van-empty
      v-if="courseData.length==0"
      style="padding-top: 0px;"
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
      description="最近没有课程哦~"
      image-size="100"
    >
    </van-empty>
  </div>
</template>

<script>
export default {
  props: {
    courseData: {
      type: Array,
      default: []
    },
  },
  filters: {
    defineFormatDate(date){
      let day = app.tool.date.formatDatetime(date,'yyyy-MM-dd'),
          today = app.tool.date.formatDatetime(Date.now(),'yyyy-MM-dd');
      if (day == today){
        return '今日/' + app.tool.date.getWeek(date)
      } else {
        return app.tool.date.formatDatetime(date,"MM-dd") + '/' + app.tool.date.getWeek(date)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.home-schedule-comp.schedule-content {
  padding: calc(var(--gap) * 12) calc(var(--gap) * 7) calc(var(--gap) * 12) calc(var(--gap) * 7);
  background-color: var(--white);
  .schedule-box {
    display: flex;
    margin-bottom: calc(var(--gap) * 12);
    .schedule-item {
      padding: 0 5px;
      width: 33.33%;
      .date {
        position: relative;
        padding-left: calc(var(--w) * 7);
        margin-bottom: calc(var(--gap) * 8);
        color: var(--g6);
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        font-weight: var(--bold);
        &::before {
          content: "";
          position: absolute;
          top: calc(var(--w) * 3);
          left: 0;
          width: calc(var(--w) * 3);
          height: calc(var(--w) * 10);
          border-radius: calc(var(--w) * 2);
          background-color: var(--c1);
        }
      }
      .content {
        position: relative;
        padding: calc(var(--gap) * 8);
        background-color: var(--g1);
        border-radius: var(--radius-sm);
        overflow: hidden;
        .time {
          position: relative;
          font-size:var(--fs-ex1);
          line-height:var(--lh-ex1);
          font-weight: var(--bold);
          z-index: 2;
          .t1 {
            font-size:var(--fs-xs);
            line-height:var(--lh-xs);
          }
        }
        .t2 {
          position: relative;
          margin-top: calc(var(--gap) * 4);
          font-size:var(--fs-sm);
          line-height:var(--lh-sm);
          color: var(--g6);
          z-index: 2;
        }
        .tag {
          display: inline-block;
          position: absolute;
          bottom: 0;
          right: 0;
          padding: calc(var(--gap) * 2) calc(var(--gap) * 6);
          font-size:var(--fs-xs);
          line-height:var(--lh-xs);
          background-color: var(--c1);
          color: var(--white);
          border-radius: 8px 0px 8px 0px;
        }
        .end-icon{
          position: absolute;
          width: calc(var(--w) * 48);
          height: calc(var(--w) * 48);
          bottom: calc(var(--w) * -10);
          right: calc(var(--w) * -6);
          z-index: 1;
        }
      }
    }
  }
  .schedule-more {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    color: var(--g6);
  }
}
</style>